import { ServiceName } from '@deltasierra/integrations-integration-types';
import { StringIdentifier } from '@deltasierra/string-ids';
import { PlatformId } from '../platform/Platform';
import { IntegrationLevel, IntegrationLevelId, IntegrationLevelIdType, toIntegrationLevelId } from './IntegrationLevel';

/**
 * This is the integration id type, it can be serialized easy
 */
export type IntegrationId = StringIdentifier<[IntegrationLevelIdType, IntegrationLevelId, PlatformId], 'IntegrationId'>;
export const IntegrationId = StringIdentifier.createStringIdentifier<IntegrationId>({
    parts: [
        StringIdentifier.Serializers.number(),
        StringIdentifier.Serializers.number(),
        StringIdentifier.Serializers.number(),
    ],
});

export function toIntegrationId(
    level: IntegrationLevel,
    levelId: IntegrationLevelIdType,
    platformId: PlatformId,
): IntegrationId {
    const integrationLevelId = toIntegrationLevelId(level);
    return IntegrationId.create([levelId, integrationLevelId, platformId]);
}

export interface Integration {
    /**
     * This is the hashed integration name, type and id in the following format:
     * 'mailchimp.location.42'
     * 'sendgrid.client.40'
     * '${integrationName}.${agency/client/location}.${agency/client/location id}'
     */
    id: IntegrationId;

    /**
     * This is the name of the service, it is static and will never change
     */
    name: ServiceName;

    /**
     * Is the integration enabled?
     * This is true if the integration is enabled on the client level
     * Currently we can only enable/disable a integration from the client level, therefore at the agency level,
     * all integrations are enabled
     */
    isEnabled: boolean;

    /**
     * Is the integration required?
     * This is true if the integration is required on the client level
     * Currently we can only require a integration from the client level, therefore at the agency level,
     * all integrations are not required
     */
    isRequired: boolean;

    /**
     * This is the human readable name of the integration.  It can change
     */
    displayName: string;
}
